import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { path } from 'ramda';
import Table from '../../сomponents/Table';
import Color from '../../common/Color';
import Status from '../../common/Status';
import Breadcrumbs from '../../common/Breadcrumbs';
import ConfirmAction from '../../common/ConfirmAction';
import { changeModalState } from '../../actions/modal';
import { deleteObject } from '../../actions/objectToDelete';
import {
  getJobCards,
  deleteJobCardById,
  updatePropertyEnableForJobCardById,
} from '../../api/jobCards';
import Preloader from "../../common/Preloader";
import hasAccess from "../../helpers/permissionChecker";

export class JobCards extends Component {

  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.handlerEdit = this.handlerEdit.bind(this);
    this.handlerDelete = this.handlerDelete.bind(this);
    this.addJobCard = this.addJobCard.bind(this);
    this.handlerStop = this.handlerStop.bind(this);
    this.handlerStart = this.handlerStart.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);

    this.state = {
      items: Array.from([]),
      container: false,
      search: '',
      itemsPerPage: 10,
      loading: true,
      currentPage: 0,
    };

    this.columns = [
      'label',
      'enabled',
    ];

    this.columnNames = [
      'Label',
      'Status',
    ];
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  componentDidUpdate() {
    const { loading } = this.state;
    const itemList = path(['jobCards', 'list'], this.props);
    if (loading && itemList) {
      this.setState({ loading: false });
    }
  }

  onChangeCurrentPage(currentPage) {
    this.setState({
      currentPage: currentPage,
    });
  }

  handlerEdit(id) {
    this.props.moveToEdit(id);
  }

  handlerDelete(id) {
    this.props.handleObjectToDelete({
      id: parseInt(id),
      handler: deleteJobCardById,
    });

    this.props.handleModalState({
      isOpen: !this.props.modal.isOpen,
      modalId: 'deleteJobCardById',
    });
  }

  addJobCard() {
    this.props.moveToAdd();
  }

  componentWillMount() {
    this.props.list();
  }

  handlerStop(id) {
    this.props.setJCStatus(id, {
      enable: 0,
    });
  }

  handlerStart(id) {
    this.props.setJCStatus(id, {
      enable: 1,
    });
  }

  render() {
    const { loading } = this.state;
    const itemList = path(['jobCards', 'list'], this.props);
    const itemActions = {
      stop: {
        handler: this.handlerStop,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-ban icon-stack-3x'],
        iconClass: '',
        context: this,
        bind: {
          show: {
            enabled: '1',
          },
        },
        hasWrapper: true,
        title: 'stop',
      },
      start: {
        handler: this.handlerStart,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-check icon-stack-1x'],
        iconClass: '',
        context: this,
        bind: {
          show: {
            enabled: '0',
          },
        },
        hasWrapper: true,
        title: 'start',
      },
      edit: {
        handler: this.handlerEdit,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-pencil icon-stack-1x'],
        iconClass: '',
        context: this,
        hasWrapper: true,
        title: 'edit',
      },
      delete: {
        handler: this.handlerDelete,
        icon: ['fa fa-circle-thin icon-stack-3x', 'fa fa-times icon-stack-1x'],
        iconClass: '',
        context: this,
        bind: {
          show: {
            enabled: '0',
          },
        },
        hasWrapper: true,
        title: 'delete',
      }
    };

    const mainPart = loading ? <Preloader show={true} type='circle'/> :
      <Table
        items={itemList}
        columns={this.columns}
        columnNames={this.columnNames}
        itemsPerPage={this.state.itemsPerPage}
        search={this.state.search}
        actions={itemActions}
        currentPage={this.state.currentPage}
        onChangeCurrentPage={this.onChangeCurrentPage}
        rowContainers={{
          color: Color,
          enabled: Status,
        }}
        onSearch={this.onSearch}
        onChangeItemsPerPage={this.onChangeItemsPerPage}
      />;
    return (
      <div style={{ paddingBottom: '25px' }}>
        <Breadcrumbs list={[
          { url: '/pages/dashboards', icon: 'dashboard', name: 'Dashboard' },
          { icon: 'card_travel', name: 'Job Cards' },
        ]}/>
        <div className="card rounded">
          <div className="card-header rounded-top">
            Job Cards
          </div>
          <div className="card-block">
            {hasAccess({ 'permAreaKey': 'jobCard', 'permTypeKey': 'create' }) &&
            <div className="clearfix mb-3">
              <button className="btn btn-rounded btn-icon ui-btn pull-right" onClick={this.addJobCard}>
                <i className="material-icons">add_circle_outline</i>
                <span className="color-default">Add</span>
              </button>
            </div>
            }

            {mainPart}
            <ConfirmAction id={'deleteJobCardById'}/>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {
    list: () => {
      getJobCards()(dispatch);
    },
    moveToEdit: (id) => {
      dispatch(push('/pages/job-cards-edit/' + id));
    },
    deleteJobCard: () => {

    },
    setJCStatus: (id, data) => {
      updatePropertyEnableForJobCardById(id, data)(dispatch);
    },
    moveToAdd: () => {
      dispatch(push('/pages/job-cards-add'));
    },
    handleModalState: (data) => {
      dispatch(changeModalState(data));
    },
    handleObjectToDelete: (data) => {
      dispatch(deleteObject(data));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(JobCards);



// WEBPACK FOOTER //
// ./src/containers/JobCards/index.js